"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.history = exports.configureStore = void 0;
const history_1 = require("history");
const redux_1 = require("redux");
const connected_react_router_1 = require("connected-react-router");
const redux_thunk_1 = __importDefault(require("redux-thunk"));
const ReducerRegistry_1 = __importDefault(require("./ReducerRegistry"));
const history = (0, history_1.createBrowserHistory)({ basename: '/' });
exports.history = history;
const configureStore = (injectings = {}, sentryEnhancer = null, initialState = {}) => {
    const combine = (reducers) => {
        const newReducers = Object.assign({}, reducers);
        const reducerNames = Object.keys(reducers);
        Object.keys(initialState).forEach((item) => {
            if (reducerNames.indexOf(item) === -1) {
                newReducers[item] = (state = null) => state;
            }
        });
        newReducers.router = (0, connected_react_router_1.connectRouter)(history);
        return (0, redux_1.combineReducers)(newReducers);
    };
    const reducer = combine(ReducerRegistry_1.default.getReducers());
    const middleware = [
        redux_thunk_1.default.withExtraArgument(Object.assign({ history }, injectings)),
        (0, connected_react_router_1.routerMiddleware)(history),
    ];
    const enchancers = [
        (0, redux_1.applyMiddleware)(...middleware),
    ];
    if (sentryEnhancer) {
        enchancers.push(sentryEnhancer);
    }
    // @ts-ignore
    const store = (0, redux_1.createStore)(reducer, initialState, (0, redux_1.compose)(...enchancers));
    ReducerRegistry_1.default.setChangeListener((reducers) => {
        store.replaceReducer(combine(reducers));
    });
    return store;
};
exports.configureStore = configureStore;
